import Chart from 'chart.js'

Chart.defaults.global.defaultFontFamily = '"Sansation", sans-serif'
Chart.defaults.global.defaultFontSize = 15

Chart.defaults.global.plugins.labels = {
  render: () => '',
  position: 'outside',
  outsidePadding: 10,
  fontSize: 15,
  fontFamily: '"SansationBold", sans-serif',
}


// WEBPACK FOOTER //
// ./src/plugins/chartjs.js